import { useQuery } from '@tanstack/react-query';

import { QUERY_KEY_INTERSTITIAL } from '@wwe-portal/web/utils/constants/keys';
import { getInterstitialByPage } from '@wwe-portal/web/services/client/interstitial';
import { LONG_CACHE_TIME } from '@wwe-portal/web/utils/config';
import { useGetCurrentUser } from './user-info';

export const useInterstitialQuery = () => {
  const currentUser = useGetCurrentUser();
  return useQuery({
    queryKey: [QUERY_KEY_INTERSTITIAL, { userId: currentUser?.userId }],
    queryFn: () => getInterstitialByPage(),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    gcTime: LONG_CACHE_TIME,
  });
};
